export default __webpack_public_path__ + "static/media/Headshot.1d21bf4f.jpeg";